import ElectronService from "./ElectronService";
import GlobalStorageService from "./GlobalStorageService";

const ConfigService = {
  boot(cb) {
    if (ElectronService.isElectron()) {
      window.mainAPI.receive("configResponse", (config) => {
        console.log(config);
        GlobalStorageService.setItem("config", config);
        cb && cb(null, "Booted Config Service");
      });
      window.mainAPI.send("getConfig");
      return;
    }
    cb && cb(null);
  },
};

export default ConfigService;
